import { Text, View } from "dripsy";
import * as React from "react";

function AuthItem({ icon, title }: { icon: any; title: string }) {
  return (
    <View
      sx={{
        marginLeft: 6,
        marginTop: 6,
        marginRight: 6,
        marginBottom: 6,
        alignItems: "center",
        flexDirection: "row",
      }}
    >
      <View>{icon}</View>
      <Text
        sx={{
          fontSize: 16,
          fontWeight: "600",
          marginLeft: "$2",
          color: "$textSecondary",
        }}
      >
        {title}
      </Text>
    </View>
  );
}
export default AuthItem;
